import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/settings";
import SmoothScroll from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
      <SettingsProvider>
      <CartProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/account" element={<Account />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-center" theme="light" />
      </CartProvider>
      </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
